import { Configuration, PopupRequest } from "@azure/msal-browser";
import { getAzureConfig } from "../utils/envUtils";

// Get Azure AD configuration from environment variables
const azureConfig = getAzureConfig();

// MSAL configuration
export const msalConfig: Configuration = {
    auth: {
        clientId: azureConfig.clientId,
        authority: azureConfig.authority,
        redirectUri: window.location.origin,
    },
    cache: {
        // localStorage so MSAL accounts/tokens are shared across tabs (e.g. middle-click view in new tab).
        // On-behalf-of, direct-auth token, and nav stack remain in sessionStorage elsewhere.
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        // Increase timeout for iframe token acquisition to handle slow connections
        windowHashTimeout: 60000, // 60 seconds (default is 6000ms)
        // Allow redirects in iframe (needed for silent token refresh)
        allowRedirectInIframe: true,
        // Increase navigation wait time for iframe
        navigateFrameWait: 500, // Wait 500ms for iframe navigation (default is 0)
        // Use async popup handling for better performance
        asyncPopups: false,
    }
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest: PopupRequest = {
    scopes: azureConfig.scopes,
    domainHint: azureConfig.domainHint
};

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
}; 